var _path, _path2, _path3, _circle, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg120X120NotFound = function Svg120X120NotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeDasharray: "4 6",
    strokeLinecap: "round",
    strokeMiterlimit: 16,
    strokeWidth: 2,
    d: "M18 18h48v64H18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m85.41 89.385 2.828-2.829 7.07 7.071a2 2 0 0 1-2.828 2.829l-7.07-7.071Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m87.53 92.92 4.243-4.242 12.021 12.02a3 3 0 1 1-4.243 4.243l-12.02-12.02Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.853,
    cy: 71,
    r: 24,
    stroke: "#000",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M79.752 61.1c5.468 5.468 5.468 14.332 0 19.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m91.773 95.749 2.829-2.829"
  })));
};
export default Svg120X120NotFound;